export default __webpack_public_path__ + "static/media/371.8b1f8435.png";